import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getClipById } from 'store/actions';
import MediaType from 'Flow2/util/MediaFile';
import Clip from 'Flow2/util/Clip';
import { isNLW, isVifogra } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

const initialState = {
    activeClipListType: null,
    activeClipListId: null,
    clipLists: {},
    clipInLists: {},
    order: [],
    sort: { orderBy: '', order: '' },
    error: null,
    loading: false,
    clips: {},
    filter: (isNLW() || isVifogra()) ? ['video', 'pictures', 'other', 'audio'] : ['video', 'pictures', 'other'],
    download: null,
    arrange: false,
    arrangedListSaved: true,
    reload: false,
    checkTranscoding: false,
    transcoding: [],
    transcodingChecker: null,
    playerDerivatives: null,
    clipsLoadedByInternalLink: {},
	cliplistFields: ["content","status","title","stock"],
    gridSize: 0
};

const getClipListStart = (state, action) => {
    return updateObject(state, { error: null, loading: true, arrangedListSaved: true });
}
const getClipListFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}
const getClipListSuccess = (state, action) => {
    let clips = [];
    let allClips = { ...state.clips };
    //this is a lookup table to find the projects that contain the clip
    let clipInLists = { ...state.clipInLists };
    //let mediaCount = isNLW() ? { video: 0, pictures: 0, other: 0, audio: 0 } : { video: 0, pictures: 0, other: 0 };
    let mediaCount = { video: 0, pictures: 0, other: 0, audio: 0 };
    action.payload.clipList.clips.elements.forEach(element => {
        if (clipInLists[element.id]) {
            clipInLists[element.id] = [...clipInLists[element.id]];
            if (clipInLists[element.id].indexOf(action.payload.id) === -1) {
                clipInLists[element.id].push(action.payload.id);
            }
        } else {
            clipInLists[element.id] = [action.payload.id];
        }

        let mediaTypes = [];
        mediaTypes = Object.keys(element.media.fields);
        mediaCount[MediaType.getMediaType(mediaTypes, element.mediafiles.elements)] += 1;
        if (-1 === clips.findIndex((e) => e.id === element.id)) {
            clips.push(element.id);
        }

        allClips[element.id] = Clip.parseClip(element, state.playerDerivatives);
        //element.addEventListener('update', function(e) { console.log(e)});

    });
    let clipList = { clips: clips, mediaCount: mediaCount, originalObject: action.payload.cliplist, lastLoadTime: Date.now() };
    let newState = updateObject(state, {
        loading: false,
        clipLists: updateObject(state.clipLists, { [action.payload.id]: clipList }),
        clipInLists: clipInLists,
        activeClipListType: action.payload.type,
        activeClipListId: action.payload.id,
        clips: allClips
    });
    return newState;
}

const setClipList = (state, action) => {
    let newState = updateObject(state, {
        activeClipListType: action.payload.type,
        activeClipListId: action.payload.id
    });
    return newState;
}

const searchSuccess = (state, action) => {
    let clips = { ...state.clips };
    let elements;
    if (action.payload.clips && action.payload.clips.objects && action.payload.clips.objects.elements)
        elements = action.payload.clips.objects.elements;
    else if (action.payload.clips && action.payload.clips.clip && action.payload.clips.clip.elements)
        elements = action.payload.clips.clip.elements;

    Object.keys(elements).forEach(id => {
        let element = elements[id];
        clips[id] = Clip.parseClip(element, state.playerDerivatives);
        // element.addEventListener('update', (e) => { console.log("UPDATE EVENT"); });
    });

    return updateObject(state, { clips: updateObject(state.clips, clips) });
}

const seriesGetClipsSuccess = (state, action) => {
    try {
        let clips = { ...state.clips };
        Object.keys(action.clips).forEach(id => {
            clips[id] = Clip.parseClip(action.clips[id], state.playerDerivatives);
        });

        return updateObject(state, { clips: updateObject(state.clips, clips) });
    } catch (err) {
        console.log("LAMTEST seriesGetClipsSuccess ERROR");
    }
}

const updateClip = (state, action) => {
    let clip = action.clip;
    let cliplists = state.clipInLists[clip.id];
    let updatedCliplists = {};

    console.log(clip.id);
    console.log(state);
    console.log(clip);

    /*cliplists.forEach(listId => {
        let cliplist = state.clipLists[listId];
        let pos = cliplist.clips.findIndex((c) => c.id == clip.id);
        if(pos > -1) {
            cliplist.clips[pos] = clip;
        }
    });*/

    //return updateObject(state, {clips: updateObject(state.clips, {[clip.id]: clip})});
    return state;
}

const addClipToProject = (state, action) => {
    let listId = action.payload.projectId;
    let clipId = action.payload.clipId;
    let cliplist = state.clipLists[listId];
    if (cliplist) {
        if (cliplist.clips.indexOf(clipId) === -1) {
            //add
            let clips = cliplist.clips.slice();
            clips.unshift(clipId);
            let newCount = { ...cliplist.mediaCount };
            newCount[action.payload.type] += 1;
            cliplist = updateObject(cliplist, { clips: clips, mediaCount: newCount });
            return updateObject(state, { clipLists: updateObject(state.clipLists, { [listId]: cliplist }) });
        }
    }
    return state;
}
const addClipsToProject = (state, action) => {
    let listId = action.payload.projectId;
    let clipIds = action.payload.clipIds.split(',');
    let cliplist = state.clipLists[listId];

    if (cliplist) {
        let newCount = { ...cliplist.mediaCount };
        let clips = cliplist.clips.slice();
        clipIds.forEach((clipId) => {
            if (clips.indexOf(clipId) === -1) {

                clips.unshift(clipId);
                if (state.clips[clipId]) {
                    newCount[state.clips[clipId].mediaType] += 1;
                }

            }
        });
        cliplist = updateObject(cliplist, { clips: clips, mediaCount: newCount });
        return updateObject(state, { clipLists: updateObject(state.clipLists, { [listId]: cliplist }) });
    }
    return state;
}

const removeClipFromProject = (state, action) => {
    let listId = action.payload.projectId;
    let cliplist = state.clipLists[listId];

    let clips = cliplist.clips.filter(clip => clip !== action.payload.clipId);
    let newCount = { ...cliplist.mediaCount };
    newCount[action.payload.type] -= 1;
    cliplist = updateObject(cliplist, { clips: clips, mediaCount: newCount });
    return updateObject(state, { clipLists: updateObject(state.clipLists, { [listId]: cliplist }) });
}
const removeClipsFromProject = (state, action) => {
    let listId = action.payload.projectId;
    let cliplist = state.clipLists[listId];
    let toDelete = action.payload.clipIds.split(',');
    let newCount = { ...cliplist.mediaCount };
    let clips = [];
    cliplist.clips.forEach((id) => {
        if (toDelete.indexOf(id) < 0) {
            clips.push(id);
        } else {
            if (state.clips[id] && state.clips[id].mediaType) {
                newCount[state.clips[id].mediaType] -= 1;
            }
        }
    })

    cliplist = updateObject(cliplist, { clips: clips, mediaCount: newCount });
    return updateObject(state, { loading: false, clipLists: updateObject(state.clipLists, { [listId]: cliplist }) });
}

const projectDeleted = (state, action) => {
    let newProjects = { ...state.clipLists };
    delete (newProjects[action.payload.projectId]);
    return updateObject(state, { clipLists: newProjects });
}

const changeSortOrder = (state, action) => {
    if (action.payload.target == 'cliplist') {

        try {
            const orderBy = action.payload.sortOrder.split('|')[0];
            const order = action.payload.sortOrder.split('|')[1];

            let cliplist = { ...state.clipLists[state.activeClipListId] };

            if (order == 'ASC') {
                cliplist.clips = cliplist.clips.slice().sort((id1, id2) => state.clips[id1].metadata[orderBy] > state.clips[id2].metadata[orderBy] ? 1 : -1);
            } else {
                cliplist.clips = cliplist.clips.slice().sort((id1, id2) => state.clips[id1].metadata[orderBy] > state.clips[id2].metadata[orderBy] ? -1 : 1);
            }

            return updateObject(state, { clipLists: updateObject(state.clipLists, { [state.activeClipListId]: cliplist }), sort: { orderBy: orderBy, order: order } });
        } catch (e) {
            console.log("TEST changeSortOrder");
        }
    }
    return state;
}

const getClipListByIdSuccess = (state, action) => {
    let allClips = { ...state.clips };
    const elements = action.payload.clipList.clip.elements;

    console.log(elements);

    for (let key in elements) {
        allClips[key] = Clip.parseClip(elements[key], state.playerDerivatives);
    }

    let newState = updateObject(state, {
        loading: false,
        clips: allClips
    });
    return newState;
}


const getClipByIdSuccess = (state, action) => {
    let allClips = { ...state.clips };
    allClips[action.id] = Clip.parseClip(action.clip, state.playerDerivatives);

    let newState = updateObject(state, {
        //loading: false,
        clips: allClips
    });
    return newState;
}

/*
 * Arrange cliplist after drag and drop clips on other position in cliplist.
 */
const arrangeClipList = (state, action) => {
    const clipLists = state.clipLists;
    const clipListId = state.activeClipListId;
    const clipIds = action.payload.clipIds;
    const refId = action.payload.refClipId;
    const pos = action.payload.pos;

    if (!clipListId || !clipLists[clipListId]) {
        return updateObject(state, {
            arrange: false
        });
    }

    let arrangedClipList = [];
    clipLists[clipListId].clips.forEach((id) => {
        if (clipIds.indexOf(id) === -1) {
            if (id === refId) {
                if (pos === 'behind') {
                    // insert clips behind current id
                    arrangedClipList.push(id);
                    clipIds.forEach((i) => {
                        arrangedClipList.push(i);
                    });
                } else {
                    // insert clips before current id
                    clipIds.forEach((i) => {
                        arrangedClipList.push(i);
                    });
                    arrangedClipList.push(id);
                }
            } else {
                arrangedClipList.push(id);
            }
        }
    });

    clipLists[clipListId].clips = arrangedClipList;

    return updateObject(state, {
        clipLists: clipLists,
        arrange: false
    });
}

const setTranscoding = (state, action) => {
    if (!state.transcoding.length && action.transcoding.length) {
        console.log("TRANSCODING: new ids", action.transcoding);
    }

    return updateObject(state, { transcoding: action.transcoding });
}

const loadClipByInternalLink = (state, action) => {
    let ids = { ...state.clipsLoadedByInternalLink };
    if (!ids[action.id]) {
        ids[action.id] = action.id;
    }
    return updateObject(state, { clipsLoadedByInternalLink: ids });
}

const removeClipByInternalLink = (state, action) => {
    let ids = { ...state.clipsLoadedByInternalLink };
    if (ids[action.id]) {
        delete ids[action.id];
    }
    return updateObject(state, { clipsLoadedByInternalLink: ids });
}

//depending on cliplistType we load clips from project, room, cliplist ....
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CLIPLIST_START: return getClipListStart(state, action);
        case actionTypes.GET_CLIPLIST_SUCCESS: return getClipListSuccess(state, action);
        case actionTypes.GET_CLIPLIST_FAIL: return getClipListFail(state, action);
        case actionTypes.GET_CLIPLIST_BY_ID_SUCCESS: return getClipListByIdSuccess(state, action);
        case actionTypes.GET_CLIP_BY_ID_SUCCESS: return getClipByIdSuccess(state, action);
        case actionTypes.SEARCH_SUCCESS: return searchSuccess(state, action);
        case actionTypes.SERIES_GET_CLIPS_SUCCESS: return seriesGetClipsSuccess(state, action);
        case actionTypes.SEARCH_NEXT_SUCCESS: return searchSuccess(state, action);
        case actionTypes.CLIP_UPDATE_RECEIVED: return updateClip(state, action);
        case actionTypes.ADD_CLIP_TO_PROJECT_SUCCESS: return addClipToProject(state, action);
        case actionTypes.ADD_CLIPS_TO_PROJECT_SUCCESS: return addClipsToProject(state, action);
        case actionTypes.REMOVE_CLIP_FROM_PROJECT_SUCCESS: return removeClipFromProject(state, action);
        case actionTypes.REMOVE_CLIPS_FROM_PROJECT_SUCCESS: return removeClipsFromProject(state, action);
        case actionTypes.REMOVE_CLIPS_FROM_PROJECT_START: return updateObject(state, { loading: true });
        case actionTypes.REMOVE_CLIPS_FROM_PROJECT_FAIL: return updateObject(state, { loading: false });
        case actionTypes.REMOVE_CLIPS_FROM_ROOM_SUCCESS: return removeClipsFromProject(state, action);
        case actionTypes.REMOVE_CLIPS_FROM_ROOM_START: return updateObject(state, { loading: true });
        case actionTypes.REMOVE_CLIPS_FROM_ROOM_FAIL: return updateObject(state, { loading: false });
        case actionTypes.DELETE_PROJECT_SUCCESS: return projectDeleted(state, action);
        case actionTypes.CLIPLIST_SET_FILTER:
            return updateObject(state, { filter: action.payload });
        case actionTypes.CLIPLIST_TOGGLE_FILTER:
            const filterToToggle = action.payload.filter;
            let newState = null;
            if (state.filter.indexOf(filterToToggle) > -1) {
                //remove filter from array
                newState = updateObject(state, { filter: state.filter.filter(entry => entry !== action.payload.filter) });
                localStorage.setItem('filter', JSON.stringify(newState.filter));
            } else {
                //add filter to array 
                newState = updateObject(state, { filter: state.filter.concat(action.payload.filter) });
                localStorage.setItem('filter', JSON.stringify(newState.filter));
            }
            return newState;
        case actionTypes.SET_SORTORDER: return changeSortOrder(state, action);
        case actionTypes.CLIPLIST_DOWNLOAD_START:
            if (!action.payload.id) {
                return updateObject(state, { download: { downloadFile: null, preparingDownload: true } });
            }
            return updateObject(state, { clipLists: updateObject(state.clipLists, { [action.payload.id]: updateObject(state.clipLists[action.payload.id], { downloadFile: null, preparingDownload: true }) }) });
        case actionTypes.CLIPLIST_DOWNLOAD_SUCCESS:
            if (!action.payload.id) {
                return updateObject(state, { download: { downloadFile: action.payload.downloadFile, preparingDownload: false } });
            }
            return updateObject(state, { clipLists: updateObject(state.clipLists, { [action.payload.id]: updateObject(state.clipLists[action.payload.id], { downloadFile: action.payload.downloadFile, preparingDownload: false }) }) });
        case actionTypes.CLIPLIST_DOWNLOAD_FAIL:
            if (!action.payload.id) {
                return updateObject(state, { download: { downloadFile: 'error', preparingDownload: false } });
            }
            return updateObject(state, { clipLists: updateObject(state.clipLists, { [action.payload.id]: updateObject(state.clipLists[action.payload.id], { downloadFile: 'error', preparingDownload: false }) }) });
        case actionTypes.CLIPLIST_RESET_DOWNLOAD:
            return updateObject(state, { download: null });
        case actionTypes.SET_CLIPLIST:
            return setClipList(state, action);
        case actionTypes.ARRANGE_CLIPLIST_START:
            return updateObject(state, { arrange: true, arrangedListSaved: false });
        case actionTypes.ARRANGE_CLIPLIST_AND_END:
            return arrangeClipList(state, action);
        case actionTypes.SAVE_ARRANGED_CLIPLIST_START:
            return updateObject(state, { loading: true });
        case actionTypes.SAVE_ARRANGED_CLIPLIST_SUCCESS:
            return updateObject(state, { loading: false, arrangedListSaved: true });
        case actionTypes.SAVE_ARRANGED_CLIPLIST_FAIL:
            return updateObject(state, { loading: false, arrangedListSaved: true });
        case actionTypes.CLIPLIST_RESTORE_START:
            return updateObject(state, { reload: true });
        case actionTypes.CLIPLIST_RESTORE_SUCCESS:
            return updateObject(state, { reload: false });
        case actionTypes.CLIPLIST_RESTORE_FAIL:
            return updateObject(state, { reload: false });
        case actionTypes.CLIPLIST_DELETE_START:
            return updateObject(state, { reload: true });
        case actionTypes.CLIPLIST_DELETE_SUCCESS:
            return updateObject(state, { reload: false });
        case actionTypes.CLIPLIST_DELETE_FAIL:
            return updateObject(state, { reload: false });
        case actionTypes.CHECK_TRANSCODING_START:
            clearInterval(state.transcodingChecker);
            return updateObject(state, { checkTranscoding: true, transcodingChecker: action.transcodingChecker });
        case actionTypes.CHECK_TRANSCODING_END:
            clearInterval(state.transcodingChecker);
            return updateObject(state, { checkTranscoding: false, transcodingChecker: null, transcoding: [] });
        case actionTypes.CHECK_TRANSCODING_SUCCESS:
            return setTranscoding(state, action);
        case actionTypes.CLIPLIST_SET_PLAYER_DERIVATIVES:
            return updateObject(state, { playerDerivatives: action.derivatives });
        case actionTypes.LOAD_CLIP_BY_INTERNAL_LINK:
            return loadClipByInternalLink(state, action);
        case actionTypes.REMOVE_CLIP_BY_INTERNAL_LINK:
            return removeClipByInternalLink(state, action);
		case actionTypes.CLIPLIST_SETUP_LIST_FIELDS:
            return updateObject(state, { cliplistFields: action.fields });
        case actionTypes.CLIPLIST_ZOOM:
            return updateObject(state, { gridSize: action.size });
        default:
            return state;
    }
}

export default reducer;
